import usePaging from "../../../hooks/usePaging";
import { useGetAssessmentsQuery } from "../assessmentsSlice";
import { useLocation } from "react-router-dom";
import useOrganisationId from "../../organisations/hooks/useOrganisationId";
import useHasAccess from "../../../hooks/useHasAccess";

const useAssessments = () => {
  const { activePage } = usePaging({});
  const location = useLocation();
  const organisationId = useOrganisationId();
  const hasAccess = useHasAccess({
    apiCall: "organisations.id.assessments.GET",
    organisation: organisationId,
  });

  const assessments = useGetAssessmentsQuery(
    {
      id: organisationId,
      page: location?.pathname?.includes("assessments") ? activePage : 1,
    },
    {
      skip: organisationId == null || !hasAccess,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    }
  );

  return {
    ...assessments,
    data: assessments?.data?.response,
    pagination: assessments?.data?.pagination,
    hasAccess,
  };
};

export default useAssessments;
